/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';

document.addEventListener('DOMContentLoaded', () => {
    const ctx = document.querySelector('#anbp-rates-chart');

    if (ctx && window.ratesData) {
        const labels = window.ratesData.rates.map(item => item.date);
        const data = window.ratesData.rates.map(item => item.rate);
        const minValue = Math.min(...data);
        const maxValue = Math.max(...data);

        new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: window.ratesData.label,
                    data: data,
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 1,
                    fill: false,
                }],
            },
            options: {
                responsive: true,
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            unit: 'day'
                        }
                    },
                    y: {
                        suggestedMin: minValue,
                        suggestedMax: maxValue,
                    }
                },
                interaction: {
                    mode: 'index'
                }
            }
        });
    }
});
